import { Course } from 'types/AppTypes';

export const excludeCoursesFromAllCourses = (excluded: number[], courses?: Course[]) => {
  try {
    if (courses) {
      const filteredCourses: Course[] = courses.filter(el => !excluded.includes(el.id));
      const filteredIds: number[] = filteredCourses?.map(c => c.id);
      return filteredIds;
    } else return excluded;
  } catch (error) {
    return excluded;
  }
};
